/**
 * Theme constants used across the application
 */

export const THEME_STORAGE_KEY: string = "yoshiDashboardTheme";

export const DARK_THEME_CLASS: string = "dark";

/* Literal types, not ThemeMode, so comparisons narrow without a cast. */
export const LIGHT_THEME: "light" = "light";
export const DARK_THEME: "dark" = "dark";
export const SYSTEM_THEME: "system" = "system";

/** Media query used to follow the operating system preference. */
export const PREFERS_DARK_QUERY: string = "(prefers-color-scheme: dark)";

/*
 * Configured tag colours keep their hue and saturation in dark mode and only
 * move in lightness, so a tag still reads as the colour it was configured with.
 */
export const DARK_TAG_SURFACE_LIGHTNESS: number = 22;
export const DARK_TAG_INK_LIGHTNESS: number = 80;
export const DARK_TAG_MIN_SATURATION: number = 45;
